export const RENT_CHARGE_FIELDS = [
  { key: "rent", label: "Rent" },
  { key: "water", label: "Water" },
  { key: "garbage", label: "Garbage" },
  { key: "service_charge", label: "Service Fee" },
  { key: "late_fee", label: "Late Fee" },
  { key: "arrears", label: "Arrears" },
  { key: "unpaid_deposit", label: "Unpaid Deposit" },
];

export function getInvoiceChargeValue(invoice, field) {
  // Finalized and previously overridden amounts belong to the invoice, even at zero.
  if (invoice.isCreated || invoice.isEdited?.[field]) return invoice[field] ?? 0;
  if (field === "rent") return invoice.tenant?.house?.rent ?? invoice.rent ?? 0;
  const propertyFields = {
    garbage: "garbage_charge",
    service_charge: "service_charge",
    late_fee: "late_fee",
  };
  return invoice.property?.[propertyFields[field]] ?? invoice[field] ?? 0;
}

export function updateInvoiceEdit(edits, invoice, field, value) {
  const id = invoice._id || invoice.id;
  const next = { ...edits, [id]: { ...edits[id] } };
  const amount = value === "" ? "" : Number(value);
  if (amount !== "" && amount === Number(getInvoiceChargeValue(invoice, field))) {
    delete next[id][field];
  } else {
    next[id][field] = amount;
  }
  if (Object.keys(next[id]).length === 0) delete next[id];
  return next;
}

export function validateInvoiceEdits(edits) {
  for (const changes of Object.values(edits)) {
    for (const [field, value] of Object.entries(changes)) {
      const label = RENT_CHARGE_FIELDS.find((charge) => charge.key === field)?.label || field;
      if (value === "" || !Number.isFinite(value)) return `${label} must be a valid number`;
      if (!["arrears", "late_fee"].includes(field) && value < 0) return `${label} cannot be negative`;
    }
  }
  return null;
}
